import http from 'hub-http/clients/noPortalApiClient';
const ACCOUNTS_API_BASE = '/accounts/v1/accounts';
const DEFAULT_PORTAL_API = '/accounts/v1/default-portal';
export default class AccountsAPI {
  static getAccounts(includePins, includeStats) {
    return http.get(`${ACCOUNTS_API_BASE}/`, {
      timeout: 10000,
      query: {
        includePins,
        includeStats
      }
    });
  }
  static getAccountsCrossHublet(includePins, includeStats) {
    return http.get(`${ACCOUNTS_API_BASE}/cross-hublet`, {
      timeout: 10000,
      query: {
        includePins,
        includeStats
      }
    });
  }
  static setPinnedAccounts(pinnedAccounts) {
    return http.put(`${ACCOUNTS_API_BASE}/pinned`, {
      data: pinnedAccounts
    });
  }
  static setDefaultAccount(portalId) {
    return http.put(DEFAULT_PORTAL_API, {
      data: {
        portalId
      }
    });
  }
  static deleteDefaultAccount() {
    return http.delete(DEFAULT_PORTAL_API);
  }
}